"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var pinStyles = styles_1.makeStyles(function (theme) { return ({
    pinContainer: {
        width: '24px',
        height: '24px',
        cursor: 'pointer',
        position: 'absolute',
        top: '-24px',
        left: '-12px',
    },
    indexContainer: {
        position: 'absolute',
        color: theme.palette.common.white,
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: 0,
    },
    selected: {
        '& svg': {
            '& path': {
                fill: theme.palette.primary.main,
            },
        },
    },
    disabled: {
        '& svg': {
            '& path': {
                fill: theme.palette.primaryDisabled.main,
            },
        },
    },
}); }, { name: 'Checkout_DealerMapPin' });
exports.default = pinStyles;
